import { render, staticRenderFns } from "./gc-popup-shifts.vue?vue&type=template&id=4f4c3cd2"
import script from "./gc-popup-shifts.vue?vue&type=script&lang=js"
export * from "./gc-popup-shifts.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-shifts.vue?vue&type=style&index=0&id=4f4c3cd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports